/*
 app dependencies
 - var body

 lib dependencies
*/

//loader and misc sidebar code
const scSidebar = (function($)
{
    const   _triggers = document.querySelectorAll('.js-show-sidebar'),
            _contentCover = document.querySelector('.js-content-cover');

    let     _popStateFired = false;

	//module functions
	function init()
	{
        _initContentLoading();

        _contentCover.addEventListener('click', function(e)
        {
            hide();
        });

        if (_triggers.length)
        {
            window.addEventListener("popstate", function(e)
            {
                for (const trigger of _triggers)
                {
                    if (trigger.dataset.loadOn == 'demand')
                    {
                        const sidebarId = trigger.dataset.sidebarId;
                        let sidebarDiv = document.querySelector(`#${sidebarId}`);
                        if (!sidebarDiv)
                        {
                            _popStateFired = true;
                            _loadContent(trigger);
                        }
                        else
                        {
                            scSidebarFilters.updateState();
                        }
                    }
                }
            });
        }
	}


    /******************************************************
    * CONTENT LOADING
    ******************************************************/

    function _initContentLoading()
    {
        for (const trigger of _triggers)
        {
            if (trigger.dataset.loadOn == 'pageload')
            {
                _loadContent(trigger);
            }
            else
            {
                trigger.addEventListener('click', function(e)
                {
                    e.preventDefault();
                    _loadContent(this);
                });
            }
        }
    }

        function _loadContent(trigger)
        {
            const sidebarId = trigger.dataset.sidebarId;
            let sidebarDiv = document.querySelector(`#${sidebarId}`);
            if (!sidebarDiv)
            {
                //element does not exist, create it
                sidebarDiv = document.createElement("div");
                sidebarDiv.id = sidebarId;
                sidebarDiv.classList.add('sidebar');
                sidebarDiv.classList.add('sidebar--loading');
                sidebarDiv.classList.add(`sidebar--${sidebarId}`);
                document.body.appendChild(sidebarDiv);
            }
            if (sidebarDiv.dataset.loadState != 'loading' && sidebarDiv.dataset.loadState != 'loaded')
            {
                sidebarDiv.dataset.loadState = 'loading';
                doAjax({
                    ajaxUrl: trigger.dataset.contentFrom,
                    params: {
                        sidebarDiv
                    },
                    onSuccess: _onLoadSuccess,
                    onError: _onLoadError
                });
            }
        }

            function _onLoadSuccess(rawResponse, params)
            {
                try
                {
                    var response = $.parseJSON(rawResponse);
                    if (response.success)
                    {
                        _initContent(response, params);
                    }
                    else throw new Error(response.message);
                }
                catch (err) { alert(err.message); }
            }


            function _onLoadError(jqxhr, textStatus, errorThrown, params)
            {
                //error?
                if (!userAbortedAjax(jqxhr)) alert(errorThrown);
            }



    /******************************************************
    * WHEN CONTENT LOADED: INIT CONTENT
    ******************************************************/

    function _initContent(response, params)
    {
        const jsModule = window[response.jsModule] || false;

        //set loaded
        params.sidebarDiv.dataset.loadState = 'loaded';
        params.sidebarDiv.classList.remove('sidebar--loading');
        //add content
        params.sidebarDiv.innerHTML = response.html;

        //init misc stuff
        _initHide(params.sidebarDiv);
        _initOptionSelection(params.sidebarDiv);
        scUi.enhanceForms($(params.sidebarDiv));

        //sidebar flow?
        if (params.sidebarDiv.querySelector('.js-sidebar-flow')) _initSidebarFlow(params.sidebarDiv);

        //dispatch loaded event to sidebar module
        if (jsModule)
        {
            jsModule.contentLoaded(params.sidebarDiv, _popStateFired);

            if (_popStateFired)
            {
                scSidebarFilters.updateState();
            }

        }
    }
        function _initHide(sidebarDiv)
        {
            const hideTriggers = sidebarDiv.querySelectorAll('.js-hide-sidebar');
            for (const hideTrigger of hideTriggers)
            {
                hideTrigger.addEventListener('click', function(e)
                {
                    e.preventDefault();
                    hide();
                });
            }
        }

    /******************************************************
    * INIT SIDEBAR FLOW
    ******************************************************/
    function _initSidebarFlow(sidebarDiv)
    {
        //forwards
        Array.from(sidebarDiv.querySelectorAll('.js-sidebar-flow__forward')).forEach(function(forwardBtn)
        {
            forwardBtn.addEventListener('click', function(e)
            {
                e.preventDefault();
                if (this.dataset.forwardTarget)
                {
                    //fade out current
                    $(this).closest('.sidebar__container')[0].classList.add('sidebar__container--inactive');
                    //slide in sub
                    document.querySelector(this.dataset.forwardTarget).classList.add('sidebar__container--visible');
                }
            });
        });
        //backs
        Array.from(sidebarDiv.querySelectorAll('.js-sidebar-flow__back')).forEach(function(backBtn)
        {
            backBtn.addEventListener('click', function(e)
            {
                e.preventDefault();
                back();
            });
        });
    }

    function back()
    {
        //fade in parent
        if (document.querySelector('.sidebar__container--inactive'))
            document.querySelector('.sidebar__container--inactive').classList.remove('sidebar__container--inactive');
        //slide out current
        if (document.querySelector('.sidebar__container--visible'))
            document.querySelector('.sidebar__container--visible').classList.remove('sidebar__container--visible');
    }


    /******************************************************
    * LABEL UPDATING
    ******************************************************/
    function _initOptionSelection(sidebarDiv)
    {
        const optionInputs = sidebarDiv.querySelectorAll('.js-sidebar-option-input');
        Array.from(optionInputs).forEach(function(input)
        {
            input.addEventListener('change', function(e)
            {
                const label = document.querySelector(this.dataset.update);

                if (label)
                {
                    if (this.parentNode.dataset.match)
                    {
                        label.textContent = this.parentNode.dataset.match;
                    }
                    else
                    {
                        label.textContent = this.nextElementSibling.textContent;
                    }

                }
                back();
            });
        });
    }


    /******************************************************
    * SHOW / HIDE SIDEBAR
    ******************************************************/

    function show(sidebarBodyClass)
    {
        //console.log(`scSidebar.show(${sidebarBodyClass})`);
        //use a timeout here so adding classes triggers transition
        setTimeout(function()
        {
            body.classList.add('show-sidebar');
            body.classList.add(sidebarBodyClass);
        }, 10);



    }
    function hide()
    {
        removeClassesStartingWith(body, 'show-sidebar');
    }



	//reveal public vars and functions
	return {
		//vars

		//functions
		init,

        show,
        hide,

        back
	};

})(jQuery);
